/* eslint sort-keys: "error" */
export default {
  /* german */
  de: {
    'change_team': 'Firma wechseln',
    'change_team_error': 'Konnte Firma nicht ändern',
    'logout': 'Abmelden',
    'quick_create': {
      'new_company': 'Neue Firma',
      'new_invoice': 'Neue Rechnung',
      'new_item': 'Neue Produktvorlage',
      'new_person': 'Neue Person',
      'new_quote': 'Neues Angebot'
    },
    'toolbar_search': '"F" drücken zum suchen',
    'toolbar_search_mobile': 'Globale Suche'
  },

  /* english */
  en: {
    'change_team': 'Change Company',
    'change_team_error': 'Could not change company',
    'logout': 'Sign out',
    'quick_create': {
      'new_company': 'New company',
      'new_invoice': 'New invoice',
      'new_item': 'New article',
      'new_person': 'New person',
      'new_quote': 'New quote'
    },
    'toolbar_search': 'Press "F" to search',
    'toolbar_search_mobile': 'Global Search'
  }
}
